import { render, staticRenderFns } from "./formsConfigurationList.vue?vue&type=template&id=738f51a4&"
import script from "./formsConfigurationList.vue?vue&type=script&lang=js&"
export * from "./formsConfigurationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports